export const FETCH_TOKEN = "FETCH_TOKEN";
export const FETCH_NEW_TOKEN = "FETCH_NEW_TOKEN";
export const LOGOUT = "LOGOUT";
export const FORGOT_PASSWORD_SEND_SMS = "FORGOT_PASSWORD_SEND_SMS";
export const FORGOT_PASSWORD_VERIFY_CODE = "FORGOT_PASSWORD_VERIFY_CODE";
export const FORGOT_PASSWORD_UPDATE_PASSWORD = "FORGOT_PASSWORD_UPDATE_PASSWORD";
